<template>
    <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
        <Slide v-for="item in VenueCarousel" :key="item.id">
            <div class="gallery-widget-item">
                <a href="javascript:void(0);" data-fancybox="gallery1">
                    <img class="img-fluid" alt="Image" :src="require(`@/assets/img/gallery/gallery1/${item.Image}`)">
                </a>
            </div>
        </Slide>
        <template #addons>
            <Navigation />
        </template>
    </Carousel>
</template>

<script>
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import VenueCarousel from '@/assets/json/venue-carousel.json'
export default {
    data() {
        return {
            VenueCarousel: VenueCarousel,
            settings: {
                itemsToShow: 1,
                snapAlign: "center",
            },
            breakpoints: {
                575: {
                    itemsToShow: 2,
                    snapAlign: "center",
                },
                767: {
                    itemsToShow: 2,
                    snapAlign: "center",
                },
                991: {
                    itemsToShow: 3,
                    snapAlign: "center",
                },
                1024: {
                    itemsToShow: 5,
                    snapAlign: "start",
                },
            },
        }
    },
    components: {
        Carousel,
        Slide,
        Navigation,
        Pagination
    },
}
</script>